// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".awsui_root_5a145_lf5uo_9:not(#\\9 ){display:contents}.awsui_inline-container_5a145_lf5uo_13:not(#\\9 ){word-break:break-all}.awsui_inline-container-trigger_5a145_lf5uo_16:not(#\\9 ){margin-inline-end:var(--space-scaled-xxs-9g5fvl, 4px)}", ""]);
// Exports
module.exports = exports;
